import {CampaignTypes, HeaderModalType} from '../../../../types/src';
import {Button} from 'antd';
import React from 'react';

export const getSelectedTypeWarningIfNeeded = (
  campaignType,
  client,
  isInstantlyVerified,
  rb2bLatestEvent,
  setHeaderModal
) => {
  const campaignTypeSettings = {
    [CampaignTypes.AcquisitionCsvInstantly]: {
      text: (
        <span style={{color: 'var(--color-main-orange)'}}>
          To enable Website Visitors by Instantly campaign you need to{' '}
          <Button type="link" style={{padding: 0, height: 20}} onClick={() => setHeaderModal('instantly')}>
            <span style={{textDecoration: 'underline'}}>configure</span>
          </Button>{' '}
          it.
        </span>
      ),
      configured: isInstantlyVerified,
    },
    [CampaignTypes.AcquisitionCsvRb2b]: {
      text: (
        <span style={{color: 'var(--color-main-orange)'}}>
          To enable Website Visitors by RB2B campaign you need to{' '}
          <Button type="link" style={{padding: 0, height: 20}} onClick={() => setHeaderModal('rb2b')}>
            <span style={{textDecoration: 'underline'}}>configure</span>
          </Button>{' '}
          it.
        </span>
      ),
      configured: rb2bLatestEvent,
    },
    [CampaignTypes.AcquisitionCsvSquid]: {
      text: (
        <span style={{color: 'var(--color-main-orange)'}}>
          To enable Website Visitors by Squid campaign you need to{' '}
          <Button type="link" style={{padding: 0, height: 20}} onClick={() => setHeaderModal(HeaderModalType.SQUID)}>
            <span style={{textDecoration: 'underline'}}>configure</span>
          </Button>{' '}
          it.
        </span>
      ),
      configured: false,
    },
    [CampaignTypes.AcquisitionCsvVector]: {
      text: (
        <span style={{color: 'var(--color-main-orange)'}}>
            To enable Website Visitors by Vector campaign you need to{' '}
          <Button
            type="link"
            style={{padding: 0, height: 20}}
            href="https://app.vector.co/integrations/webhook"
            target="_blank"
            rel="noreferrer nofollow"
          >
              <span style={{textDecoration: 'underline'}}>configure</span>
            </Button>{' '}
          it.
          </span>
      ),
      configured: false,
    },
    [CampaignTypes.AcquisitionCsvApi]: {
      text: (
        <span style={{color: 'var(--color-main-orange)'}}>
          To enable LinkedIn Profiles URLs via API campaign you need to{' '}
          <Button type="link" style={{padding: 0, height: 20}} onClick={() => setHeaderModal('api')}>
            <span style={{textDecoration: 'underline'}}>configure</span>
          </Button>{' '}
          it.
        </span>
      ),
      configured: client.has_api_setup,
    },
  };
  if (campaignTypeSettings[campaignType] && !campaignTypeSettings[campaignType].configured) {
    return campaignTypeSettings[campaignType].text;
  }
  return null;
};
